import React from "react";
import { Tooltip } from "antd";

const STATUS_CLASS = {
	present: "attendance-cell--present",
	late: "attendance-cell--late",
	absent: "attendance-cell--absent",
	holiday: "attendance-cell--holiday",
	on_leave: "attendance-cell--on-leave",
	annual_leave: "attendance-cell--annual-leave",
	menstrual_leave: "attendance-cell--menstrual-leave",
	sick_leave: "attendance-cell--sick-leave",
	business_trip: "attendance-cell--business-trip",
	half_day: "attendance-cell--half-day",
	pending: "attendance-cell--pending",
	empty: "attendance-cell--empty",
};

const AttendanceCell = ({ cell, onClick }) => {
	if (!cell) {
		return <div className="attendance-cell attendance-cell--empty" />;
	}

	const isWeeklyOff =
		cell.status === "holiday" && cell.holiday_kind === "정기휴일";
	const workedOnWeeklyOff = Boolean(cell.worked_on_weekly_off);
	const workedOnHoliday = Boolean(cell.worked_on_holiday);
	const showDiagonal = isWeeklyOff || workedOnWeeklyOff;
	const showExcuseMark = Boolean(cell.has_excuse);
	const isHalfDay = cell.status === "half_day";
	const halfPortion = cell.half_day; // 'am' | 'pm'
	const viewable = Boolean(cell.leave_applications?.length);
	const recordable = Boolean(cell.can_record_clock);
	const clickable = Boolean(
		onClick && (viewable || cell.can_override || recordable),
	);
	const isEmpty = cell.status === "empty";

	const className = [
		"attendance-cell",
		STATUS_CLASS[cell.status] || "attendance-cell--empty",
		isWeeklyOff ? "attendance-cell--weekly-off" : "",
		workedOnWeeklyOff ? "attendance-cell--weekly-off-worked" : "",
		workedOnHoliday ? "attendance-cell--holiday-worked" : "",
		showExcuseMark ? "attendance-cell--excuse-applied" : "",
		isHalfDay && halfPortion === "am"
			? "attendance-cell--half-am"
			: "",
		isHalfDay && halfPortion === "pm"
			? "attendance-cell--half-pm"
			: "",
		viewable ? "attendance-cell--viewable" : "",
		clickable && (cell.can_override || recordable) && !viewable
			? "attendance-cell--clickable"
			: "",
	]
		.filter(Boolean)
		.join(" ");

	const inner = (
		<div
			className={className}
			role={clickable ? "button" : undefined}
			tabIndex={clickable ? 0 : undefined}
			onClick={
				clickable
					? (event) => {
							event.stopPropagation();
							onClick(cell);
						}
					: undefined
			}
			onKeyDown={
				clickable
					? (event) => {
							if (event.key === "Enter" || event.key === " ") {
								event.preventDefault();
								onClick(cell);
							}
						}
					: undefined
			}>
			{isHalfDay ? (
				<span className="attendance-cell__half-fill" aria-hidden />
			) : null}
			{showDiagonal ? (
				<span className="attendance-cell__diagonal" aria-hidden />
			) : null}
			{showExcuseMark ? (
				<span className="attendance-cell__excuse-dot" aria-hidden />
			) : null}
		</div>
	);

	if (!cell.tooltip && isEmpty && !showExcuseMark) {
		return inner;
	}

	if (!cell.tooltip) {
		return inner;
	}

	return <Tooltip title={cell.tooltip}>{inner}</Tooltip>;
};

export default AttendanceCell;
